import React from 'react';
import { Alert } from 'antd';
import { Outlet } from 'react-router-dom';
import Spinner from '../spinner/Spinner';
import ShoppingNav from '../shoppingNav';
import ShoppingCartAlerts from './ShoppingCartAlerts';
import ShoppingCartEmptyState from './ShoppingCartEmptyState';
import ShoppingCartItems from './ShoppingCartItems';
import ShoppingCartSummaryPanel from './ShoppingCartSummaryPanel';
import { useShoppingCartPage } from './useShoppingCartPage';
import './shoppingCartPage.scss';

const ShoppingCartPage: React.FC = () => {
  const {
    animateClass,
    cartItems,
    checkoutDisabledMessage,
    error,
    firstCartIssue,
    handleCheckoutCart,
    isCartEmpty,
    isCartHydrating,
    isCheckoutBlocked,
    isPricingLoading,
    isRootCartRoute,
    sizeErrors,
    status,
    totalAmount,
  } = useShoppingCartPage();

  if (!isRootCartRoute) {
    return <Outlet />;
  }

  if (isCartHydrating) return <Spinner />;
  if (status === 'failed' && error && cartItems.length === 0) {
    return <Alert message="Error" description={error} type="error" showIcon />;
  }

  return (
    <div className="shopping-cart-container">
      <div className="cart-header">
        <ShoppingNav />
      </div>
      <ShoppingCartAlerts
        error={error}
        firstCartIssueMessage={firstCartIssue?.message}
      />
      <div className="shopping-cart-page">
        <div className={`shopping-cart-main ${animateClass}`}>
          {isCartEmpty ? (
            <ShoppingCartEmptyState />
          ) : (
            <ShoppingCartItems cartItems={cartItems} sizeErrors={sizeErrors} />
          )}
        </div>
        {!isCartEmpty && (
          <ShoppingCartSummaryPanel
            animateClass={animateClass}
            checkoutDisabledMessage={checkoutDisabledMessage}
            isCheckoutBlocked={isCheckoutBlocked}
            isPricingLoading={isPricingLoading}
            totalAmount={totalAmount}
            onCheckout={handleCheckoutCart}
          />
        )}
      </div>
    </div>
  );
};

export default ShoppingCartPage;
